import React from "react";
import { OnboardingMilestoneType, MilestoneStatus } from "../lib/types";

interface Milestone {
  type: OnboardingMilestoneType;
  sequence: number;
  status: MilestoneStatus;
  metadata?: {
    progressPercent?: number;
    messagesSynced?: number;
    totalToSync?: number;
    elapsedTime?: number;
  };
}

interface AccountSetupTrackerProps {
  milestones: Milestone[];
}

const getMilestoneLabel = (type: OnboardingMilestoneType): string => {
  switch (type) {
    case OnboardingMilestoneType.VERIFY_GMAIL:
      return "Setting up";
    case OnboardingMilestoneType.SYNC_SENT_MESSAGES:
      return "Syncing sent messages";
    case OnboardingMilestoneType.POST_SENT_SYNC_ANALYSIS:
      return "Building your rules";
    case OnboardingMilestoneType.SYNC_RECEIVED_MESSAGES:
      return "Syncing received messages";
    case OnboardingMilestoneType.ENABLE_FILTERING:
      return "Finishing up!";
    default:
      return "";
  }
};

const getStatusColor = (status: MilestoneStatus): string => {
  switch (status) {
    case MilestoneStatus.COMPLETED:
      return "bg-green-500";
    case MilestoneStatus.IN_PROGRESS:
      return "bg-blue-500";
    case MilestoneStatus.FAILED:
      return "bg-red-500";
    case MilestoneStatus.PENDING:
      return "bg-gray-300";
    default:
      return "bg-gray-300";
  }
};

const AccountSetupTracker: React.FC<AccountSetupTrackerProps> = ({
  milestones,
}) => {
  return (
    <div className="w-full pb-10 pt-10">
      {/* Dots and lines */}
      <div className="flex items-center justify-center mb-2">
        {milestones.map((milestone, idx) => (
          <React.Fragment key={milestone.type}>
            <div className="relative flex flex-col items-center">
              <div
                className={`w-4 h-4 rounded-full ${getStatusColor(milestone.status)}`}
              />
              <div className="absolute left-1/2 -translate-x-1/2 top-6 text-xs text-center text-gray-600 dark:text-gray-400 whitespace-wrap">
                {getMilestoneLabel(milestone.type)}
                {milestone.status === MilestoneStatus.IN_PROGRESS &&
                  milestone.metadata?.progressPercent !== undefined && (
                    <div className="mt-1 text-xs text-blue-500">
                      {milestone.metadata?.progressPercent}%
                    </div>
                  )}
              </div>
            </div>
            {idx < milestones.length - 1 && (
              <div
                className="w-12 h-0.5 mx-2"
                style={{
                  backgroundColor:
                    milestone.status === MilestoneStatus.COMPLETED
                      ? "#22c55e"
                      : "#d1d5db",
                }}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default AccountSetupTracker;
